export default "__VITE_ASSET__DAbv3L1Z__"